export default __webpack_public_path__ + "static/media/check.282463b1.svg";